import { Dropdown, MenuProps } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import brFlag from "../../assets/img/bandeiras/br.svg";
import pyFlag from "../../assets/img/bandeiras/py.svg";

export const LanguageDropdown: React.FC = () => {
  const { t, i18n } = useTranslation(["common"]);

  const items: MenuProps["items"] = [
    {
      label: t("common:changeLanguage"),
      type: "group",
    },
    {
      type: "divider",
    },
    {
      key: "1",
      label: "Português",
      icon: <img src={brFlag} alt="Brazilian flag" width={20} />,
      onClick: () => void i18n.changeLanguage("pt"),
    },
    {
      key: "2",
      label: "Español",
      icon: <img src={pyFlag} alt="Paraguay flag" width={20} />,
      onClick: () => void i18n.changeLanguage("es"),
    },
  ];

  return (
    <div title={t('common:changeLanguage')}>
      <Dropdown menu={{ items }} trigger={["click"]}>
        <GlobalOutlined style={{ cursor: 'pointer', color: '#B576DD' }} />
      </Dropdown>
    </div>
  );
};
